import { useState } from "react";
import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";
import AIAssistant from "@/components/AIAssistant";

export default function Layout({ title, subtitle, children }) {
  const [aiOpen, setAiOpen] = useState(false);
  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar onOpenAI={() => setAiOpen(true)} />
      <div className="ml-64">
        <Header title={title} subtitle={subtitle} />
        <main className="p-8 max-w-[1400px] mx-auto">{children}</main>
      </div>
      <AIAssistant open={aiOpen} onClose={() => setAiOpen(false)} />
    </div>
  );
}
